/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";

import { ReactNode } from "react";

import { defaultLocale } from "@i18n/config";

const loadedLocaleMapping: { [key: string]: any } = {
	"en-US": en,
};

/**
 * Configured for English only since Legal Hub won't be using this component.
 * No need to load all 32 languages when we won't use it.
 *
 */
export const DateToTimeAgo = (): ReactNode | null => {
	const locale = defaultLocale;
	if (!locale || locale.indexOf(".") > -1) {
		return null;
	}

	const localePackage = loadedLocaleMapping[locale];
	if (!localePackage) {
		console.error(`Failed to load javascript-time-ago locale: ${locale}`);
		return null;
	}
	TimeAgo.addLocale(localePackage);
};
